// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessagesContentWrapper__messages-fd6cb3 {
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  /* FF fix, https://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox */
  min-height: 0;
  padding-top: 12px;
  padding-bottom: 12px;
}

.MessagesContentWrapper__messages-fd6cb3:empty {
  display: none;
}

.MessagesContentWrapper__messages-fd6cb3 > *:first-child {
  margin-top: auto;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/MessagesContentWrapper/MessagesContentWrapper.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,OAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,4GAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".messages {\n  overflow-x: hidden;\n  overflow-y: auto;\n  box-sizing: border-box;\n  flex: 1;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  /* FF fix, https://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox */\n  min-height: 0;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\n.messages:empty {\n  display: none;\n}\n\n.messages > *:first-child {\n  margin-top: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messages": `MessagesContentWrapper__messages-fd6cb3`
};
module.exports = ___CSS_LOADER_EXPORT___;
